import React, { useState } from "react";
import "./Footer.css";
import logo from "../../Assets/logo.png";
import paymentIcon from "../../Assets/paymentIcon.png";
import { FaFacebookF, FaInstagram, FaYoutube, FaPinterest } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { newsletterDb } from "../../firebase/newsletterConfig";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const validateEmail = (email) => {
    const emailRegex = /\S+@\S+\.\S+/;
    return emailRegex.test(email);
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");
    if (!email || !validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    try {
      await addDoc(collection(newsletterDb, "subscribers"), {
        email: email,
        timestamp: serverTimestamp(),
      });
      setSuccessMessage("Thank you for subscribing!");
      setEmail("");
    } catch (err) {
      console.error("Error adding document: ", err);
      setError("Subscription failed. Please try again later.");
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <footer className="footer">
        <div className="footer__container">
          {/* LEFT & MIDDLE SECTIONS */}
          <div className="footer_left">
            <div className="footer_logo_container">
              <img src={logo} alt="Zircon Jewels Logo" />
            </div>
            <p>Hussain Center, Zabunnisa street, Saddar, Karachi, Pakistan</p>
            <div className="footer_address">
              <strong> zircongemsandjewels@gmail.com </strong>
              <strong> +92 328 2243950 </strong>
            </div>
            <div className="footer_content">
              <h2>Wholesale</h2>
              <ul className="footer-text-list"> {/* <-- CLASSNAME ADDED HERE */}
                <li>We provide nationwide bulk delivery services to Islamabad, Lahore, and other major cities.</li>
                <li>Interested customers can contact us via phone.</li>
              </ul>
            </div>  
            <br />
            
            <ul className="social_links">
              <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a></li>
              <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaXTwitter /></a></li>
              <li><a href="https://instagram.com/zircon___jewels" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a></li>
              <li><a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube /></a></li>
              <li><a href="https://pinterest.com" target="_blank" rel="noopener noreferrer" aria-label="Pinterest"><FaPinterest /></a></li>
            </ul>
          </div>

          <div className="footer_content">
            <h2>Company</h2>
            <div className="links_container">
              <ul onClick={scrollToTop}>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/about">Career</Link></li>
                <li><Link to="*">Affilates</Link></li>
                <li><Link to="/blog">Blog</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
              </ul>
            </div>
          </div>
          <div className="footer_content">
            <h2>Shop</h2>
            <div className="links_container">
              <ul onClick={scrollToTop}>
                <li><Link to="/shop">New Arrivals</Link></li>
                <li><Link to="/shop">Accessories</Link></li>
                <li><Link to="/shop">Men</Link></li>
                <li><Link to="/shop">Women</Link></li>
                <li><Link to="/shop">Shop All</Link></li>
              </ul>
            </div>
          </div>
          <div className="footer_content">
            <h2>Help</h2>
            <div className="links_container">
              <ul onClick={scrollToTop}>
                <li><Link to="/contact">Customer Service</Link></li>
                <li><Link to="/loginSignUp">My Account</Link></li>
                <li><Link to="/contact">Find a Store</Link></li>
                <li><Link to="/terms">Legal & Privacy</Link></li>
                <li><Link to="/contact">Contact</Link></li>
                <li><Link to="/">Gift Card</Link></li>
              </ul>
            </div>
          </div>

          {/* RIGHT SECTION */}
          <div className="footer_right">
            <h2>Subscribe</h2>
            <p>
              Be the first to get the latest news about trends, promotions, and
              much more!
            </p>
            <form onSubmit={handleSubscribe}>
              <label htmlFor="newsletter-email" className="sr-only">Your email address</label>
              <input 
                id="newsletter-email" 
                type="email" 
                placeholder="Your email address" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button type="submit">Join</button>
            </form>
            {error && <p className="error-message">{error}</p>}
            {successMessage && <p className="success-message">{successMessage}</p>}
            <h3>Secure Payments</h3>
            <div className="paymentIconContainer">
              <img src={paymentIcon} alt="Secure Payment Icons" />
            </div>
          </div>
        </div>
        <div className="footer_bottom">
          <p>
            © Zircon Jewels. All Rights Reserved | Crafted by{" "}
            <a href="https://www.instagram.com/zircon___jewels/" target="_blank" rel="noopener noreferrer" style={{ color: "#C22928", textDecoration: "none" }}>
              Zircon Jewels
            </a>{" "} with ❤️
          </p>
          <div className="footerLangCurrency">
            <div className="footerLang">
              <label htmlFor="language" className="sr-only">Language</label>
              <select name="language" id="language">
                <option value="english">United States | English</option>
              </select>
            </div>
            <div className="footerCurrency">
              <label htmlFor="currency" className="sr-only">Currency</label>
              <select name="currency" id="currency">
                <option value="PKR">Rs PKR</option>
              </select>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;